import * as React from 'react';
import styled, {
  createGlobalStyle,
} from 'styled-components';
import Draggable from 'react-draggable';
import CloseIcon from '@material-ui/icons/Close';
import { ClickAwayListener } from '@material-ui/core';

import { useReactToPrint } from 'react-to-print';
import { ButtonModalClose } from '../atoms';
import { ButtonWithLoader } from './index';
import FormsReport from '../pages/Reports/FormsReport';

const ModalDefaultDraggableExact = ({
  children,
  title,
  onClose,
  className = '',
  addContactModal,
  disabledDraggable,
  centered,
  wide,
  extraWide,
  showPrintButton,
  printRef,
  exactPosition,
}: Props) => {
  const containerRef = React.useRef(null);
  const printableRef = printRef || React.useRef();
  const handlePrintInspectionForm = useReactToPrint({
    content: () => printableRef.current,
  });
  const formExportToPdf = () => {
      handlePrintInspectionForm();
  };
React.useEffect(() => {
  if (addContactModal && containerRef && containerRef.current) {
    containerRef.current.scrollTo(0, 0);
    }
}, [addContactModal]);

  return (
    <ModalContainer ref={containerRef} className={className} addContactModal={addContactModal}>
      <GlobalStyles />
      <ClickAwayListener
        onClickAway={onClose}
        mouseEvent="onMouseDown"
      >
        <Draggable
          disabled={disabledDraggable}
          cancel=".react-draggable-cancel"
          // positionOffset={exactPosition ? { x: '-50%', y: '350%' } : { x: '-50%', y: '0%' }}
          positionOffset={{ x: 0, y: '-50%' }}
          defaultPosition={exactPosition ? { x: 0, y: '-50%' } : {}}
        >
          <ModalContent
            centered={centered}
            wide={wide}
            extraWide={extraWide}
          >
            <MobileClose onTouchStart={onClose}>
              <CloseWrapper>
                <CloseIcon />
              </CloseWrapper>
            </MobileClose>
            <StyledButtonModalClose onClick={onClose} />
            <StyledTitle>{title}</StyledTitle>
            {showPrintButton && (
              <ButtonWithLoader
                variant="outlined"
                disabled={false}
                onClick={formExportToPdf}
              >
                Print
              </ButtonWithLoader>
            )}
            <ModalContentInner ref={printRef || printableRef}>
              <div>{children}</div>
            </ModalContentInner>
          </ModalContent>
        </Draggable>
      </ClickAwayListener>
    </ModalContainer>
  );
};

const GlobalStyles = createGlobalStyle`
  body {
    max-height: 100vh;
    overflow: hidden;
    padding-right: 17px;
    
    @media print {
      table[role="table"] {
        display: none;
      }
    }
  }
`;

const MobileClose = styled.button`
 width: 32px;
 height: 32px;
 border-radius:50%;
 z-index: 300;
 position: absolute;
 right:32px;
 top:32px;
 background-color:#fff;
 @media only screen and (min-width: 840px) {
   display:none;
 }
`;

const CloseWrapper = styled.div`  ;
zoom: 1.2;
position: relative;
left: -5px;
top: -2px;
`;
const ModalContainer = styled.div`
  position: fixed;
  z-index: var(--modalZIndex);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 40px 20px;
  overflow-x: hidden;
  overflow: ${props => (props.addContactModal ? 'hidden' : 'auto')};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: rgba(19, 23, 32, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  ${({ className }) =>
    className === 'over' && 'overflow: visible;'}
`;

const ModalContent = styled.div<Content>`
  background-color: var(--neutral-0);
  width: ${({ wide, extraWide }) =>
    // eslint-disable-next-line no-nested-ternary
    wide ? '1000px' : extraWide ? '1300px' : '100%'};
  min-width: 280px;
  max-width: ${({ wide, extraWide }) =>
    // eslint-disable-next-line no-nested-ternary
    wide ? '1000px' : extraWide ? '1300px' : '800px'};
  padding: var(--space-8) var(--space-8) var(--space-6);
  border-radius: var(--radius-lg);
  border: 1px solid var(--neutral-200);
  box-shadow: var(--shadow-lg);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-bottom: 100px;

  @media print {
    box-shadow: none;
    border: 0;
  }
`;

const ModalContentInner = styled.div.attrs({
  className: 'react-draggable-cancel',
})`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

const StyledTitle = styled.div`
  width: 90%;
  font-size: var(--fs-2xl);
  font-weight: var(--fw-semibold);
  color: var(--neutral-900);
  line-height: var(--lh-snug);
  text-align: center;
  margin: 0 auto var(--space-6);
  letter-spacing: -0.005em;
`;

const StyledButtonModalClose = styled(ButtonModalClose)`
  top: 20px;
  right: 20px;

  @media print {
    display: none;
  }
`;

interface Props {
  children: React.ReactNode | React.ReactNodeArray;
  title?: string;
  onClose: () => void;
  className?: string;
  centered?: boolean;
  wide?: boolean;
  extraWide?: boolean;
  showPrintButton?: boolean;
}

interface Content {
  centered?: boolean;
  wide?: boolean;
  extraWide?: boolean;
}

export default ModalDefaultDraggableExact;
